import { makeStyles } from "@material-ui/core";

const accordionStyles = makeStyles((theme) => ({
  expanded: {},
  content: {
    margin: `8px 0px`,
    "&$expanded": {
      margin: `10px 0px`,
    },
  },
  accordHead: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  tableContent: {
    margin: `0px`,
    padding: `10px 24px`,
    "&$expanded": {
      margin: `0px 0px`,
    },
  },
  tableExpanded: {
    margin: `0px 0px !important`,
    "&$expanded": {
      margin: `0px 0px`,
    },
  },
  statsAccord: {
    padding: "0px !important",
    margin: "0px !important",
    "&$expanded": {
      margin: `0px 0px`,
    },
  },
}));

export default accordionStyles;
